import { render, staticRenderFns } from "./ChecklistHistoryModal.vue?vue&type=template&id=4bdcc58e&"
import script from "./ChecklistHistoryModal.vue?vue&type=script&lang=ts&"
export * from "./ChecklistHistoryModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./../../_locales/common.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fallocations%2Foffers%2FChecklistHistoryModal.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./_locales/common.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fallocations%2Foffers%2FChecklistHistoryModal.vue"
if (typeof block1 === 'function') block1(component)
import block2 from "./_locales/ChecklistHistoryModal.json?vue&type=custom&index=2&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fallocations%2Foffers%2FChecklistHistoryModal.vue"
if (typeof block2 === 'function') block2(component)

export default component.exports